import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Overview.module.sass";
import Item from "./Item";
import Card from "../../../components/Card";
import { UseApi } from "../../../hooks/use-api";
import { GetDashCount } from "../../../Services/lib/admin";
import { useUser } from "../../../context";
import home from "../../../i11/Home";

const Overview = ({ className }) => {
	const { locale } = useUser();
	const nav = [
		{
			title: home[locale].customers,
			counter: "1024",
			icon: "people",
			color: "#B1E5FC",
			value: -37.8,
			link: "/customers/list/customer",
		},
		{
			title: home[locale].products,
			counter: "256k",
			icon: "box",
			color: "#CABDFF",
			value: 37.8,
			link: "/product",
		},
	];

	const [data, setData] = useState([0, 0]);
	const [{}, fetch] = UseApi({
		service: GetDashCount,
	});

	useEffect(() => {
		(async function () {
			const res = await fetch();
			if (res) {
				setData([res.userCounts, res.collectionCounts]);
			}
		})();
	}, []);

	return (
		<Card
			className={cn(styles.card, className)}
			title={home[locale].overview}
			classTitle="title-red"
		>
			<div className={styles.overview}>
				<div className={styles.nav}>
					{nav.map((x, index) => (
						<Item
							className={cn(styles.item)}
							key={index}
							onActive={() => {}}
							item={{ ...x, counter: data[index] }}
						/>
					))}
				</div>
			</div>
		</Card>
	);
};

export default Overview;
